import { createAsyncThunk } from '@reduxjs/toolkit';
import {
  ResponseErrorWithHandled,
  ResponseSuccess,
} from '../../../../shared/types';
import {
  getMcpSessions,
  revokeMcpSession,
} from '../../helpers/mcp-settings.api';
import {
  createApiToken,
  getApiTokenList,
  revokeApiToken,
  getMcpHashToken,
} from '../../helpers/api-token.api';
import { RevokeMcpSessionPayload } from './types';

export const getMcpSessionsRequest = createAsyncThunk<
  ResponseSuccess,
  void,
  { rejectValue: ResponseErrorWithHandled }
>('mcpSettings/getMcpSessionsRequest', async (_args, thunkAPI) => {
  try {
    return await getMcpSessions();
  } catch (e) {
    return thunkAPI.rejectWithValue(e as ResponseErrorWithHandled);
  }
});

export const MCP_API_KEY_LABEL = 'MCP - Custom Integration';

export const createMcpApiKeyRequest = createAsyncThunk<
  ResponseSuccess,
  void,
  { rejectValue: ResponseErrorWithHandled }
>('mcpSettings/createMcpApiKeyRequest', async (_args, thunkAPI) => {
  try {
    // Delete existing MCP token if one exists (label must be unique)
    const tokenListResponse = await getApiTokenList();
    const existingToken = tokenListResponse.payload?.find(
      (token: { id: number; label: string }) =>
        token.label === MCP_API_KEY_LABEL,
    );
    if (existingToken) {
      await revokeApiToken(existingToken.id);
    }

    return await createApiToken(MCP_API_KEY_LABEL);
  } catch (e) {
    return thunkAPI.rejectWithValue(e as ResponseErrorWithHandled);
  }
});

export const fetchMcpApiKeyRequest = createAsyncThunk<
  ResponseSuccess,
  void,
  { rejectValue: ResponseErrorWithHandled }
>('mcpSettings/fetchMcpApiKeyRequest', async (_args, thunkAPI) => {
  try {
    return await getMcpHashToken();
  } catch (e) {
    return thunkAPI.rejectWithValue(e as ResponseErrorWithHandled);
  }
});

export const revokeMcpSessionRequest = createAsyncThunk<
  ResponseSuccess,
  RevokeMcpSessionPayload,
  { rejectValue: ResponseErrorWithHandled }
>('mcpSettings/revokeMcpSessionRequest', async ({ sessionId }, thunkAPI) => {
  try {
    return await revokeMcpSession(sessionId);
  } catch (e) {
    return thunkAPI.rejectWithValue(e as ResponseErrorWithHandled);
  }
});
